import { BallType } from '../enums/machine.enums';
import { Nullable } from './common/i-generics';
import { IFirmwareState } from './i-machine';

export interface IConnectionSummary {
  connect_date: Nullable<string>;
  disconnect_date: Nullable<string>;
}

export interface IMachineUser {
  email: string;
  session: string;
  wsID: string;
  connectDate: string;
}

export interface IMachineSummary
  extends IConnectionSummary, Partial<IFirmwareState> {
  connected: boolean;
  calibrated: boolean;

  /** active user */
  active?: IMachineUser;

  /** users in queue */
  waiting: IMachineUser[];

  ball_type: BallType;
}

export const DEFAULT_MACHINE_SUMMARY: IMachineSummary = {
  connected: false,
  calibrated: false,
  active: undefined,
  waiting: [],
  ball_type: BallType.MLB,
  connect_date: null,
  disconnect_date: null,
};
